import { getPreferredPhone, useDeleteContact, useGetAllContacts, useGetContact, useUpdateContact } from "@api/contactService";
import React, { useContext, useEffect, useState } from "react";
import Box from '@mui/joy/Box';
import Stack from '@mui/joy/Stack';
import IconButton from '@mui/joy/IconButton';
import Tooltip from '@mui/joy/Tooltip';
import Typography from '@mui/joy/Typography';
import ObjectIndex from "@components/objects/ObjectIndex";
import LocalPhoneRoundedIcon from '@mui/icons-material/LocalPhoneRounded';
import EmailRoundedIcon from '@mui/icons-material/EmailRounded';
import ObjectShow from "@components/objects/ObjectShow";
import CloudUploadRoundedIcon from '@mui/icons-material/CloudUploadRounded';
import FileUploadRoundedIcon from '@mui/icons-material/FileUploadRounded';
import ObjectColumn from "@components/objects/ObjectColumn";
import { ObjectPrimaryInfo } from "@components/objects/ObjectPrimaryInfo";
import Avatar from "@mui/joy/Avatar";
import Alert from "@mui/joy/Alert";
import { ObjectContext } from "@providers/ObjectProvider";
import { ensureDateObject, formatAbsoluteDate, formatDate, isValidDate } from "@utils/dates";
import ObjectPreview from "@components/objects/ObjectPreview";
import { generateAddress } from "@utils/generateAddress";
import { CardOverflow, Grid, List, ListDivider, ListItem, ListItemContent, ListItemDecorator, Table } from "@mui/joy";
import AbstractObjectRelationship from "@components/objects/AbstractObjectRelationship";
import UserAccessCard from "@components/objects/UserAccessCard";
import { intervalToDuration } from "date-fns";
import ObjectEdit from "@components/objects/ObjectEdit";
import { ObjectPrimaryInfoEdit } from "@components/objects/ObjectPrimaryInfoEdit";
import { ObjectRelationshipEdit } from "@components/objects/ObjectRelationshipEdit";
import { countries } from "@utils/selectOptions";
import { ObjectRelationship } from "@components/objects/ObjectRelationship";
import SearchSelect from "@components/SearchSelect";
import { CheckPermission } from "@components/CheckPermission";
import { useDeleteEvent, useGetEvent, useUpdateEvent } from "@api/eventService";
import { useDeleteOpportunity, useGetOpportunity, useUpdateOpportunity } from "@api/opportunityService";



// import { DynamicFieldData } from "./dynamic-control-types";

const fields = [
    {
        name: 'name',
        type: 'text',
        placeholder: 'e.g. 2024 Clean Up Day',
        showRequired: true,
        config: {
            required: true,
        },
    },
    {
        name: 'event_id',
        label: 'Event',
        type: 'relationship',
        endpoint: 'events',
        defaultProp: 'event',
    },
    {
        name: 'workplan_id',
        label: 'Work Plan',
        type: 'relationship',
        endpoint: 'work-plans',
        defaultProp: 'workplan',
    },
];

export default function OpportunityEdit(props) {
    return (
        <ObjectEdit
            query={useGetOpportunity}
            mutation={useUpdateOpportunity}
            deleteMutation={useDeleteOpportunity}
            type={'opportunity'}
            permissionType={'work plans'}
            title={'Edit Opportunity'}
            subtitleKey={'name'}
            color={'default'}
            {...props}
        >
            <ObjectColumn primary>
                <ObjectPrimaryInfoEdit
                    title={'Opportunity Info'}
                    tint={'default'}
                    fields={fields}
                />
            </ObjectColumn>

            <ObjectColumn>
                <ObjectRelationshipEdit type={'time_slots'} permissions={'edit work plans'} />
            </ObjectColumn>

            <ObjectColumn full>
            <Grid container columns={12} gap={2}>
                <ObjectColumn>
                    <ObjectRelationshipEdit type={'richtext'} column={'description'} title={'Description'} permissions={'edit work plans'} />
                </ObjectColumn>
                <ObjectColumn>
                    <ObjectRelationshipEdit
                        type={'files'}
                        permissions={'edit work plans'}
                        note={
                            <Alert
                                color="warning"
                                variant="soft"
                                // size="sm"
                                sx={{
                                    borderRadius: 0,
                                    // mb: 1,
                                }}
                            >
                                <span><b>Note:</b> All uploaded files will be visible on the public sign-up link. Do not upload private files here.</span>
                            </Alert>
                        }
                    />
                </ObjectColumn>
            </Grid>
            </ObjectColumn>

            <ObjectColumn full>
                <ObjectRelationshipEdit type={'jobs'} permissions={'edit work plans'} />
            </ObjectColumn>

        </ObjectEdit>
    )
}
